import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RULE_CONFIG_SECTIONS, readPath } from '../rule-config-sections';
import { fieldControl, writePath } from '../rule-config-fields';

@Component({
  selector: 'app-rule-config-editor',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './rule-config-editor.component.html',
})
export class RuleConfigEditorComponent implements OnChanges {
  @Input() config: Record<string, unknown> | null = null;
  @Input() lockedKeys: string[] = [];
  @Input() busy = false;
  @Input() showPublish = false;
  @Output() validate = new EventEmitter<Record<string, unknown>>();
  @Output() saveDraft = new EventEmitter<Record<string, unknown>>();
  @Output() savePublish = new EventEmitter<Record<string, unknown>>();

  readonly sections = RULE_CONFIG_SECTIONS;
  draft: Record<string, unknown> = {};

  ngOnChanges(changes: SimpleChanges): void {
    // Only re-seed when the config input itself changes — other input changes
    // (e.g. `busy` toggling on Validate/Save) must not wipe the user's edits.
    if (changes['config']) {
      this.draft = this.config ? structuredClone(this.config) : {};
    }
  }

  ctrl(path: string) {
    return fieldControl(path);
  }
  value(path: string): unknown {
    return readPath(this.draft, path);
  }
  set(path: string, value: unknown): void {
    writePath(this.draft, path, value);
  }
  isLocked(path: string): boolean {
    return this.lockedKeys.includes(path);
  }
  get weightTotal(): number {
    return ['identity', 'employment_income', 'financial_snapshot', 'ai_module', 'final_decision']
      .reduce((sum, k) => sum + Number(readPath(this.draft, `scoring.weights.${k}`) ?? 0), 0);
  }
  onValidate(): void {
    this.validate.emit(this.draft);
  }
  onSave(): void {
    this.saveDraft.emit(this.draft);
  }
  onSavePublish(): void {
    this.savePublish.emit(this.draft);
  }
}
